import { Dispatch, Middleware, MiddlewareAPI } from 'redux';

import { UnknownDevice, KnownDevice } from '@playq/octopus2-devices';
import { ClientEvent } from '@playq/services-vortex';

import { BuzzerOnlineDevicesNotifications, EventType, publishEvent } from '/common/buzzer';
import { buzzerOnlineDevicesNotifications$ } from '/common/buzzer/buzzerNotifications';
import { RootState } from '/store/RootState';

import { deviceToolkit } from '../toolkits/devices/slice';

type DeviceAction = ReturnType<(typeof deviceToolkit.actions)[keyof typeof deviceToolkit.actions]>;
type AppDispatch = Dispatch<DeviceAction>;
export const deviceSocketMiddleware: Middleware = (store: MiddlewareAPI<AppDispatch, RootState>) => {
  buzzerOnlineDevicesNotifications$.subscribe((notification: BuzzerOnlineDevicesNotifications) => {
    if (notification instanceof KnownDevice || notification instanceof UnknownDevice) {
      const currentState =
        notification.connection !== undefined ? EventType.DEVICE_CONNECTED : EventType.DEVICE_DISCONNECTED;
      publishEvent(currentState, notification);

      store.dispatch(
        deviceToolkit.actions.updateConnection({
          id: notification.serialize().id,
          connection: notification.serialize().connection,
        })
      );
    } else if (notification.event instanceof ClientEvent) {
      publishEvent(EventType.STREAM_EVENT, notification);

      store.dispatch(
        deviceToolkit.actions.setEvents({
          id: notification.device.serialize(),
          event: notification.event.serialize(),
        })
      );
    }
  });

  return (next: AppDispatch) => (action: DeviceAction) => {
    return next(action);
  };
};
